import { useState, useEffect } from "react";

const CountdownTimer = ({ targetDate, eventName, location, compact = false }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(targetDate) - new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (compact) {
    return (
      <div className="flex items-center justify-center gap-2" data-testid={`countdown-compact-${eventName || 'timer'}`}>
        <div className="bg-white/10 backdrop-blur-sm rounded-lg px-3 py-1.5 text-center">
          <span className="text-lg font-bold text-white">{timeLeft.days}</span>
          <span className="text-xs text-white/70 ml-1">d</span>
        </div>
        <span className="text-white/50">:</span>
        <div className="bg-white/10 backdrop-blur-sm rounded-lg px-3 py-1.5 text-center">
          <span className="text-lg font-bold text-white">{String(timeLeft.hours).padStart(2, '0')}</span>
          <span className="text-xs text-white/70 ml-1">h</span>
        </div>
        <span className="text-white/50">:</span>
        <div className="bg-white/10 backdrop-blur-sm rounded-lg px-3 py-1.5 text-center">
          <span className="text-lg font-bold text-white">{String(timeLeft.minutes).padStart(2, '0')}</span>
          <span className="text-xs text-white/70 ml-1">m</span>
        </div>
        <span className="text-white/50">:</span>
        <div className="bg-white/10 backdrop-blur-sm rounded-lg px-3 py-1.5 text-center">
          <span className="text-lg font-bold text-white">{String(timeLeft.seconds).padStart(2, '0')}</span>
          <span className="text-xs text-white/70 ml-1">s</span>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6"
      data-testid={`countdown-${eventName?.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {eventName && (
        <div className="text-center mb-4">
          <p className="text-[#FFD700] text-xs uppercase tracking-[0.2em] font-bold">{eventName}</p>
          {location && <p className="text-gray-400 text-sm">{location}</p>}
        </div>
      )}
      
      <div className="grid grid-cols-4 gap-3">
        <div className="text-center">
          <div className="bg-[#FF3B30]/20 rounded-xl p-3 mb-2">
            <span className="text-3xl md:text-4xl font-black text-white font-['Outfit']">
              {timeLeft.days}
            </span>
          </div>
          <span className="text-xs text-gray-400 uppercase tracking-wider">Days</span>
        </div>
        <div className="text-center">
          <div className="bg-[#FFD700]/20 rounded-xl p-3 mb-2">
            <span className="text-3xl md:text-4xl font-black text-white font-['Outfit']">
              {String(timeLeft.hours).padStart(2, '0')}
            </span>
          </div>
          <span className="text-xs text-gray-400 uppercase tracking-wider">Hours</span>
        </div>
        <div className="text-center">
          <div className="bg-[#007AFF]/20 rounded-xl p-3 mb-2">
            <span className="text-3xl md:text-4xl font-black text-white font-['Outfit']">
              {String(timeLeft.minutes).padStart(2, '0')}
            </span>
          </div>
          <span className="text-xs text-gray-400 uppercase tracking-wider">Minutes</span>
        </div>
        <div className="text-center">
          <div className="bg-white/10 rounded-xl p-3 mb-2">
            <span className="text-3xl md:text-4xl font-black text-white font-['Outfit']">
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>
          <span className="text-xs text-gray-400 uppercase tracking-wider">Seconds</span>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
